import classnames from 'classnames';
import React from 'react';

/**
 * Used to create uniform modal formatting in Conjunction with ModalHeader.js, and ModalFooter.js.
 *
 * Props
 * - modalSize - size of modal, default is 'md'
 */

type Props = {
  /**
   * @default md
   */
  modalSize?: 'sm' | 'lg' | 'xl';
};

const ModalContainer: React.FC<React.PropsWithChildren<Props>> = ({ modalSize, children }) => {
  return (
    <div
      className={classnames(`modal-dialog modal-dialog-centered`, {
        [`modal-${modalSize}`]: modalSize !== undefined,
      })}
    >
      <div className="modal-content">{children}</div>
    </div>
  );
};

export default ModalContainer;
